import { render } from "./SyllabusExplorerComponent.vue?vue&type=template&id=4806e2c8&scoped=true&ts=true"
import script from "./SyllabusExplorerComponent.vue?vue&type=script&lang=ts"
export * from "./SyllabusExplorerComponent.vue?vue&type=script&lang=ts"

import "./SyllabusExplorerComponent.vue?vue&type=style&index=0&id=4806e2c8&lang=postcss&scoped=true"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4806e2c8"]])

export default __exports__